export default "__VITE_ASSET__CzUtpl_I__"